export function mapNotNull<T, U>(arr: T[], fn: (item: T) => U | null | undefined): U[] {
  const result: U[] = [];
  for (const item of arr) {
    const mapped = fn(item);
    if (mapped !== null && mapped !== undefined) {
      result.push(mapped);
    }
  }
  return result;
}

/**
 * Maps an array of objects to an array of values of a specific property.
 * Example:
 * ```typescript
 * const arr = [{ a: 1 }, { a: 2 }, { a: 3 }];
 * mapToProp(arr, 'a'); // [1, 2, 3]
 * ```
 * @param arr
 * @param key
 * @param includeFalsy
 */
export function mapToProp<T, P extends keyof T>(arr: T[], key: P, includeFalsy: boolean = true): Array<T[P]> {
  return arr.map((item) => item[key]).filter((item) => includeFalsy || Boolean(item));
}

/**
 * Maps an array of objects to an array of objects with specified properties.
 * @param arr
 * @param keys
 * @param includeFalsy
 */
export function mapToProps<T, P extends keyof T>(arr: T[], keys: P[], includeFalsy: boolean = true): Array<Pick<T, P>> {
  return arr.map((item) => {
    const result = {} as { [K in P]: T[K] };
    for (const key of keys) {
      if (includeFalsy || Boolean(item[key])) {
        result[key] = item[key];
      }
    }
    return result;
  });
}
